import { Pipe, PipeTransform } from '@angular/core';
import { formatTimespanLong, formatTimespanShort } from './format.util';

export type TimespanFormatStyle = 'short' | 'long';

@Pipe({
    standalone: false,
    name: 'timespanFormat',
})
export class TimespanFormatPipe implements PipeTransform {
    transform(timespan: string | null | undefined, style: TimespanFormatStyle = 'short'): string {
        if (!timespan) {
            return style === 'long' ? '0 hrs 0 min' : '00h 00m';
        }
        return style === 'long' ? formatTimespanLong(timespan) : formatTimespanShort(timespan);
    }
}
